import { DiscountTypeEnum } from "src/app/enums/DiscountTypeEnum";
import { ExpenseItemEnum } from "src/app/enums/ExpenseItemEnum";

export class DiscountPriorityDto {
  Id: number;
  ClinicId: number;
  Code: string;
  Name: string;
  StartDate?: Date;
  EndDate?: Date;
  ExpenseItem: ExpenseItemEnum;
  DiscountType: DiscountTypeEnum;
  DiscountValue: number;
  DiscountRule: string;
  Priority: number;
  Description: string;
  MakeChoice: boolean;
}

export class MapDiscountRule {
  RegisterMode: string;
  OutpatientType: string;
  ICode: string;
  SameTreat: string;
  Icno: string;
  INote: string;
  AgeStart: string;
  AgeStartExpression: string;
  AgeEnd: string;
  AgeEndExpression: string;
  Sex: string;
  Area: string;
  PatientArea: string;
  TimeSec: string;
  RoomCode: string;
  DoctorId: string;
  All: string;
  MakeChoice: string;
  Weekdays: string;
  SelfPayChoice: string;
  OwnFeeChoice: string;
}
